<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="通过" :value="2"></el-option>
          <el-option label="拒绝" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addNew">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
         {{getNameByValue(demandTypes,row.type)}}
        </div>
      </template>
      <template #status="{ row }">
        <div>
         {{getNameByValue(demandStatus,row.status)}}
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button
            v-if="row.status == 3"
            type="success"
            size="small"
            @click="updateStatus(row, 5)"
            >上架</el-button
          >

          <el-button
            v-if="row.status == 3"
            type="warning"
            size="small"
            @click="updateStatus(row, 6)"
            >下架</el-button
          >
          <el-button type="success" size="small" @click="details(row)"
            >详情</el-button
          >
        </div>
      </template>
    </auto-table>

  </div>
</template>

<script>
import {demandTypes,demandStatus} from '../dict.js'
import {getNameByValue} from "@/utils/utils.js"
export default {
  data() {
    return {
      demandTypes,
      demandStatus,
      DataList: [],
      Option: [
        { name: "名称", value: "title" },
        { name: "城市", value: "city" },
         { name: "状态", value: "type", type: "custom" },
        { name: "状态", value: "status", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    details(row) {
      this.$router.push({ name: "enrollDemand_d", query: { id: row.id } });
    },
    addNew() {
      this.$refs.add.open();
    },
    updateStatus(row, status) {
      this.$post("/user/enrollDemands/update", { id: row.id, status }).then(
        (res) => {
          this.$message("成功");
          this.getList(1);
        }
      );
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/enrollDemands/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>